import { useTheme } from "@mui/material/styles";

const DownloadIcon = () => {
  const theme = useTheme();

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_30081_4421)">
        <path
          d="M6.66699 9.99999L10.0003 13.3333M10.0003 13.3333L13.3337 9.99999M10.0003 13.3333V6.66666M18.3337 9.99999C18.3337 14.6024 14.6027 18.3333 10.0003 18.3333C5.39795 18.3333 1.66699 14.6024 1.66699 9.99999C1.66699 5.39762 5.39795 1.66666 10.0003 1.66666C14.6027 1.66666 18.3337 5.39762 18.3337 9.99999Z"
          stroke={theme.palette.otherBackgroundLight.main}
          strokeWidth="1.65"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_30081_4421">
          <rect
            width="20"
            height="20"
            fill={theme.palette.otherBackgroundLight.main}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DownloadIcon;
